/**
 * Đồng bộ cho danh mục chi thường xuyên trường hợp gộp nội dung
 * dvhung2 06.11.2024
 */
export default {
    Merge: 1,
    Delete: 2,
    Rename: 3,
  };